import React from 'react';
import { Link } from 'react-router-dom';
import { Footer, Header } from '../Common';
import { BuyerSidebar } from '../Common/BuyerSidebar';
import Chat from '../../Models/Chat';
import Notifications from '../../Models/Notifications';
import { Badge } from 'reactstrap';
import {withTranslation} from "react-i18next";
import Common from "../../Models/Common";
class BuyerDirectMessageList extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 1) {
            alert(this.props.t("LOGIN_ALERT"))
            this.props.history.push('/login/buyer');
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        this.state = {
            _id: false,
            activePage: 1,
            user: logged_user.id,
            openningStatus: '',
            openningStatusAdmin: '',
            thread: [],
            payload: [],
        }
        this.getMessageNotification();

    };
    componentDidMount() {
        window.scrollTo(0, 0);
        Chat.getThreadsBuyerSolo(this.state.user).then(res => {
            this.setState({ thread: res.data.payload })
        });
    }

    getMessageNotification() {
        Notifications.getAllMessage(this.state.user).then(res => {
            res.data.text.map(res => {
                if (this.state.user == res.seller_id) {
                    this.setState({ openningStatusButton: res.opening_status_receiver })
                } else if (res.buyer_id == 0) {
                    if (res.opening_status_receiver == 'Unread') {
                        this.setState({ openningStatusButtonAdmin: res.opening_status_receiver })
                    }
                } else {
                    if (res.opening_status_receiver == 'Unread') {
                        this.setState({ openningStatus: res.opening_status_receiver, buyerID: res.buyer_id })
                    }
                }
            })
            this.setState({ payload: res.data.text })
        })
    }

    openMessageStatus(receiverid, senderId) {
        if (localStorage.getItem('info') !== null) {
            var x = JSON.parse(localStorage.getItem('info'))
            Notifications.openMessageStatus(receiverid, senderId).then(res => {
                if (res.data.payload !== null) {
                    console.log(res.data.message)
                    this.setState({ unreadStatus: res.data.payload })
                }
            })
            this.getMessageNotification();
        }
    }

    messageNotificationBadge(id, i, sellerId,status) {
        if (this.state.user == id) {
            if (sellerId == i) {
                // console.log(sellerId,i)
                if (status == 'Unread') {
                    return (
                        <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', fontSize: '18px', marginTop: '4px' }} ><i class="fas fa-exclamation-circle"></i></Badge>
                    )
                }
            }
        }
    }

    messageNotificationBadgeAdmin() {
        const isMobile = window.innerWidth <= 500;
        if (isMobile) {
            if (this.state.openningStatusButtonAdmin === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', position: 'absolute', zIndex: '100', marginTop: '-8px', marginLeft: "5px" }} ><i class="fas fa-exclamation-circle"></i></Badge>
                )
        } else {
            if (this.state.openningStatusButtonAdmin === 'Unread')
                return (
                    <Badge className="" style={{ padding: '0px', color: '#dc3545', backgroundColor: '#fff', position: 'absolute', zIndex: '100', marginTop: '-8px', marginLeft: "-5px" }}><i class="fas fa-exclamation-circle"></i></Badge>
                )
        }
    }

    handlePageChange(pageNumber) {
        console.log(`active page is ${pageNumber}`);
        this.setState({ activePage: pageNumber });
    }
    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="container-fluid">
                        <div className="row">
                            {/* <div className="col-md-4 input_name">
                                <BuyerSidebar />
                            </div> */}
                            <div className="col-md-8">
                                <div className="mt-5 input_name big_font  " style={{ fontSize: '20px', width: "100%", textAlign: 'left' }}>
                                    <div className="row">
                                        <div className="col-9" style={{ fontSize: '16px' }}>
                                            {this.props.t('BUYER_DIRECT_MESSAGE_LIST.BUYER_DIRECT_MESSAGE_TITLE')}
                                        </div>
                                        <div className="col-3" style={{ paddingBottom: "5px", textAlign: "right" }} onClick={this.openMessageStatus.bind(this, this.state.user, 0)}>
                                            <div className="pr-3">
                                                {this.messageNotificationBadgeAdmin()}
                                            </div>
                                            <Link to={'/com-with-sys'}>
                                                <img src={require('../../assets/images/admin.png')} className=" rounded-circle" alt="" width="30" height="30" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="message_show_box" style={{ minHeight: '475px' }}>
                                    <div className="message_box m-2 p-2" >
                                        {this.state.thread.map(th =>
                                            <div>
                                                <Link to={{
                                                    pathname: '/buyer-direct-message' + '/' + encodeURIComponent(th.buyer_id + "&" + th.seller_id),
                                                    state: {
                                                        buyer_id: th.buyer_id,
                                                        seller_id: th.seller_id
                                                    }
                                                }}>
                                                    <div className="row">
                                                        <div className="col-3 ">

                                                            <img src={Common.baseUrl+th.img_buyer} className=" rounded-circle" alt="" width="50" height="50" /><br />
                                                        </div>
                                                        <div className="col-7">
                                                            <div className="message_name_text">
                                                                <span><b>{th.first_name}</b></span>
                                                            </div>
                                                            <span style={{ fontSize: "10px" }}>{(JSON.stringify(th.created_at)).substring(1, 11)}</span>
                                                        </div>
                                                        <div className="col-2">
                                                            {this.state.payload.map(res =>
                                                                this.messageNotificationBadge(res.buyer_id, th.seller_id, res.seller_id,res.opening_status_receiver)
                                                            )}
                                                        </div>
                                                        {/* <div className="col-3 ">
                                                            <span style={{ fontSize: "10px" }}>{(JSON.stringify(th.created_at)).substring(1, 11)}</span>
                                                        </div> */}
                                                    </div>
                                                    <hr />
                                                </Link>
                                            </div>
                                        )}
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
        //For Desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name">
                                        <BuyerSidebar />
                                    </div>
                                    <div className="col-md-8">
                                        <div className="mb-1 input_name big_font  row" style={{ textAlign: "left", width: "100%", marginLeft: '0px' }}>
                                            <div className="col-md-7" style={{ paddingLeft: '0px' }}>
                                                {this.props.t('BUYER_DIRECT_MESSAGE_LIST.BUYER_DIRECT_MESSAGE_TITLE')}
                                            </div>
                                            <div className="col-md-5" style={{ paddingBottom: "5px", textAlign: "right" }} onClick={this.openMessageStatus.bind(this, this.state.user, 0)}>
                                                <Link to={'/com-with-sys'}>
                                                    <button style={{ borderRadius: "4px", padding: "2%", fontSize: "15px" }}>{this.props.t('BUYER_DIRECT_MESSAGE_LIST.ADMIN_MESSAGE_BTN')} </button>
                                                    {this.messageNotificationBadgeAdmin()}
                                                </Link>
                                            </div>
                                        </div>
                                        <div className="message_show_box">
                                            <div className="message_box m-2 p-2" >
                                                {this.state.thread.map(th =>
                                                    <div onClick={this.openMessageStatus.bind(this, th.buyer_id, th.seller_id)}>
                                                        <Link to={{
                                                            pathname: '/buyer-direct-message' + '/' + encodeURIComponent(th.buyer_id + "&" + th.seller_id),
                                                            state: {
                                                                buyer_id: th.buyer_id,
                                                                seller_id: th.seller_id
                                                            }
                                                        }}>
                                                            <div className="row">
                                                                <div className="col-md-2 mini_pad">
                                                                    <img src={Common.baseUrl+th.img_buyer} className=" rounded-circle" alt="" width="70" height="70" style={{ zIndex: '200', position: 'relative' }} /><br />

                                                                    {/* <div className="special_padd"><img src={require("../../assets/images/pro.png")} alt="" className="" alt="" width="30%" height="36%" /></div> */}
                                                                </div>
                                                                <div className="col-md-7 mt-3">
                                                                    <div className="message_name_text">
                                                                        <span><b>{th.first_name}</b></span><br />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2 mt-3">
                                                                    <span style={{ fontSize: "13px" }}>{(JSON.stringify(th.created_at)).substring(1, 11)}</span>
                                                                </div>
                                                                <div className="col-md-1 mt-3">
                                                                    {this.state.payload.map(res =>
                                                                        this.messageNotificationBadge(res.buyer_id, th.seller_id, res.seller_id,res.opening_status_receiver)
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <hr />
                                                        </Link>
                                                    </div>
                                                )}
                                            </div>

                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div >
            )
        }
    }
}
export { BuyerDirectMessageList }
BuyerDirectMessageList = withTranslation('buyer')(BuyerDirectMessageList);
